import logo from "./sentients-logo.svg";
import bookMockup from "./images/book-mockup-trans-1.png";
import styled from "styled-components";

import TopNav from "./TopNav";
import { Outlet, Link } from "react-router-dom";

const Page = styled.div`
  background-color: white;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding-top: 50px;
`;

const Logo = styled.img`
  width: 100%;
  max-width: 905px;
`;

const Header = styled.div`
  font-family: "Josefin Sans", sans-serif;
  font-size: 18.7px;
  letter-spacing: 0.355em;
  margin-top: 20px;
  text-align: center;
`;

function App() {
  return (
    <Page>
      <Logo src={logo} alt="logo" />
      <Header>THE ROLE-PLAYING GAME OF ARTIFICIAL CONSCIOUSNESS</Header>

      <TopNav />

      <Outlet />
    </Page>
  );
}

export default App;
